document.addEventListener("DOMContentLoaded", () => {
  const carousel = document.querySelector(".js-carousel");
  const dotsContainer = document.querySelector(".js-carousel-dots");

  if (!carousel || !dotsContainer) return;

  const items = Array.from(carousel.children);

  const totalDots = 3;
  dotsContainer.innerHTML = "";

  for (let index = 0; index < totalDots; index++) {
    const dot = document.createElement("button");
    dot.type = "button";
    dot.classList.add("carousel-dot");
    if (index === 0) dot.classList.add("active");
    dot.dataset.index = index;
    dotsContainer.appendChild(dot);
  }

  const dots = Array.from(dotsContainer.children);

  const getMaxScroll = () => carousel.scrollWidth - carousel.clientWidth;

  const updateActiveDot = () => {
    const maxScroll = getMaxScroll();
    const progress = maxScroll === 0 ? 0 : carousel.scrollLeft / maxScroll;
    const index = Math.round(progress * (totalDots - 1));

    dots.forEach(dot => dot.classList.remove("active"));
    if (dots[index]) dots[index].classList.add("active");
  };

  dots.forEach(dot => {
    dot.addEventListener("click", () => {
      const index = Number(dot.dataset.index);
      const maxScroll = getMaxScroll();
      const targetScroll = (maxScroll * index) / (totalDots - 1);

      carousel.scrollTo({
        left: targetScroll,
        behavior: "smooth"
      });
    });
  });

  const createArrow = () => {
    if (window.innerWidth >= 1024) return null;

    const arrow = document.createElement("div");
    arrow.className = "swipe-arrow";
    arrow.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path d="M2.85718 10.0001H17.1429M17.1429 10.0001L11.5874 4.44458M17.1429 10.0001L11.5874 15.5557" stroke="#222222" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>`;

    const listImagesContainer = carousel.closest(".list-images");
    if (listImagesContainer) {
      listImagesContainer.style.position = "relative";
      listImagesContainer.appendChild(arrow);
    }

    return arrow;
  };

  let swipeArrow = null;

  const updateArrow = () => {
    if (window.innerWidth >= 1024) {
      if (swipeArrow) {
        swipeArrow.remove();
        swipeArrow = null;
      }
      return;
    }

    const isAtStart = carousel.scrollLeft === 0;

    if (isAtStart) {
      if (!swipeArrow) {
        swipeArrow = createArrow();
      } else {
        swipeArrow.style.opacity = "1";
      }
    } else {
      if (swipeArrow) {
        swipeArrow.style.opacity = "0";
      }
    }
  };
  updateArrow();

  carousel.addEventListener("scroll", () => {
    updateActiveDot();
    updateArrow();
  });
  window.addEventListener("resize", () => {
    updateActiveDot();
    updateArrow();
  });

  let isDragging = false;
  let startX = 0;
  let scrollLeft = 0;

  carousel.addEventListener("touchstart", (e) => {
    isDragging = true;
    startX = e.touches[0].pageX - carousel.offsetLeft;
    scrollLeft = carousel.scrollLeft;
    carousel.style.cursor = "grabbing";
    carousel.style.scrollBehavior = "auto";
  });

  carousel.addEventListener("touchmove", (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.touches[0].pageX - carousel.offsetLeft;
    const walk = (x - startX) * 1.5;
    carousel.scrollLeft = scrollLeft - walk;
  });

  carousel.addEventListener("touchend", () => {
    isDragging = false;
    carousel.style.cursor = "grab";
    carousel.style.scrollBehavior = "smooth";
    updateActiveDot();
  });

  carousel.addEventListener("touchcancel", () => {
    isDragging = false;
    carousel.style.cursor = "grab";
    carousel.style.scrollBehavior = "smooth";
  });
});
